import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
import {
    formatterTime
} from '@/util/util'

export const unfreezeApplyOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "原押金金额",
            prop: "amount",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "修改后金额",
            prop: "editAmount",
            type: "input",

        },
        {
            label: "修改原因",
            prop: "editReason",
            type: "input",

        },
        {
            label: "充值人昵称",
            prop: "userName",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false

        },
        {
            label: "充值账号",
            prop: "account",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "账号类型",
            prop: "clientType",
            type: "select",
            dicData: DIC.CLIENT_TYPE,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "押金冻结时间",
            prop: "freezeTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "申请押金解冻时间",
            prop: "unFreezeApplyTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "押金解冻规则名称",
            prop: "unFreezeRuleName",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "状态",
            prop: "status",
            type: "select",
            dicData: DIC.UNFREEZE_APPLY_STATUS,
            addVisdiplay: false,
            editVisdiplay: false
        }
    ]
};